var React = require('react');

function Book (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.91022 0H22.0922C23.1431 0 23.9992 0.798 24 1.785V19.6448C24 20.6295 23.1439 21.429 22.0922 21.429H1.91022C0.853707 21.429 0 20.6287 0 19.6448V1.785C0 0.798 0.853707 0 1.91022 0ZM14.7479 5.87625C15.2425 5.87625 15.6361 6.09075 16.1323 6.36225L16.7246 4.266C16.5153 4.21109 16.3148 4.15314 16.1186 4.09644C15.46 3.90607 14.85 3.72975 14.1162 3.72975C13.1872 3.72975 12.2894 3.86925 11.6826 4.146C11.075 4.4235 10.6381 4.914 10.4128 5.35425C10.1868 5.796 10.0721 6.3315 10.0721 7.22625V8.076H8.55311V10.302H10.0705V17.6985H13.3218V10.302H15.3499L15.9102 8.076H13.3218V7.27575C13.3218 6.735 13.4269 6.369 13.6385 6.18C13.8501 5.9895 14.2637 5.87625 14.7479 5.87625Z","fill":"currentColor"}));
}

Book.defaultProps = {"width":"24","height":"22","viewBox":"0 0 24 22","className":"w-5 h-5 mr-3 fill-current","fill":"none"};

module.exports = Book;

Book.default = Book;
